<template>
    <div>
        <h5 class="heading-1">
            <span>PROCESSOS</span>
        </h5>
        <app-tabela
            idTabela="tblAtestoProcessos"
            :itens="processos"
            :campos="campos"
            :itensPorPagina="itensPorPagina"
            :mostrarFiltro="false"
            class="mt-4"
        >
            <template slot="valor" slot-scope="data">{{ data.valor | currency }}</template>
        </app-tabela>
    </div>
</template>

<script>
export default {
	props: {
		processos: {
			type: Array,
			default: () => []
		}
	},

	data() {
		return {
			campos: [
				{
					key: 'processo',
					label: 'Processo',
					sortable: true,
					filterable: true,
					tdClass: 'text-center'
				},
				{
					key: 'descricao',
					label: 'Descrição',
					sortable: true,
					filterable: true
				},
				{
					key: 'idRm',
					label: 'ID RM',
					sortable: true,
					filterable: true,
					tdClass: 'text-center'
				},
				{
					key: 'valor',
					label: 'Valor',
					sortable: true,
					filterable: true,
					tdClass: 'text-nowrap text-right'
				}
			],
			itensPorPagina: 0
		}
	}
}
</script>
